<template>
  <ValidationObserver
    ref="broadcastForm"
    v-slot="{ valid, pristine }">
    <b-modal
      id="broadcast-send-modal"
      ref="broadcastModalRef"
      class="static-modal"
      :modal-class="{'fit-width': !templateMessagesLoaded, preloading: !templateMessagesLoaded, 'hide-send': !hasApprovedTemplateMessages }"
      title-class="flex flex-align-center"
      centered
      hide-header-close
      :hide-footer="!templateMessagesLoaded"
      :hide-header="!templateMessagesLoaded"
      :static="true"
      size="xl"
      :lazy="true"
      no-close-on-backdrop
      @shown="onShow"
      @hidden="resetData"
      @cancel="cancelBroadcast" >
      <!-- Modal Title -->
      <template slot="modal-title">
        <SBIcon
          class="mr-2"
          :icon="SBIconList.BROADCAST"
          :color="SBColors.blackPrimary"
          :size="18"/>
        Send broadcast message
      </template>

      <template #modal-footer="{ cancel }">
        <div class="broadcast-info-wrapper flex flex-align-center greedy">
          <span
            class="broadcast-count"
            :class="{ ok: selectedContacts && selectedContacts <= maxBroadcastCalc, nok: selectedContacts && selectedContacts > maxBroadcastCalc }" >{{ selectedContacts }}</span>
          <span> of </span>
          <span>{{ maxBroadcastCalc | bigDigits }}</span>
          <span class="recepients"> recipients</span>
          <SBIcon
            id="broadcast-info"
            class="ml-1"
            :icon="SBIconList.INFO"
            :color="SBColors.greyPrimary"
            :size="12"/>
          <b-popover
            target="broadcast-info"
            custom-class="broadcast-limits"
            triggers="hover"
            placement="top">
            <div>
              <h1>WhatsApp messaging limits</h1>
              <p>Your phone number is allowed to have {{ maxBroadcastCalc | bigDigits }} business-initiated conversations (with {{ maxBroadcastCalc | bigDigits }} unique customers) in a rolling 24-hour period. Learn more about WhatsApp limits <a href="https://developers.facebook.com/docs/whatsapp/messaging-limits/" target="_blank">here</a>.</p>
            </div>
          </b-popover>
        </div>
        <b-button
          @click="cancel()">
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="(hasFieldsToPopulate && pristine) || !selectedContacts || (selectedContacts && selectedContacts > maxBroadcastCalc) || !valid"
          @click="submit()">
          <span>Send</span>
        </b-button>
      </template>

      <!-- Spinner shown while template data is being loaded. -->
      <div
        v-if="!templateMessagesLoaded"
        class="spinner-wrapper">
        <Spinner
          :size="20"
          :thickness="2"/>
      </div>

      <!-- Modal Content -->
      <div
        v-else-if="hasApprovedTemplateMessages"
        class="preview-body flex">
        <div
          class="notification-send-form greedy" >
          <div>
            <!-- FROM preview -->
            <b-form-group >
              <div class="template-label-wrapper flex space-between">
                <label>Send from</label>
              </div>
              <div class="number-from-wrapper flex flex-align-center">
                <VNodes :vnodes="getNumberIcon(number, 'number-icon')"/>
                <p>{{ number.name }}</p>
              </div>
            </b-form-group>

            <!-- TEMPLATE multiselect -->
            <b-form-group>
              <label
                class="col-form-label pt-0">
                Template
              </label>
              <multiselect
                ref="templateMultiselectRef"
                v-model="selectedTemplate"
                placeholder="Select Template"
                class="template-multiselect-options hide-tags no-selected-background no-padding"
                :class="{empty: !templateKeywords.length}"
                :options="templateKeywords"
                :preselect-first="true"
                :multiple="false"
                :searchable="true"
                :show-labels="false"
                :show-no-results="false"
                :allow-empty="false"
                @input="changeTemplate()">
                <template slot="noOptions" >
                  <span class="hide" />
                </template>
                <template
                  slot="beforeList">
                  <div
                    class="flex flex-align-center multiselect-before"
                    @click="showCreateNewMessageTemplateModal" >
                    <SBIcon
                      :icon="SBIconList.PLUS"
                      :color="SBColors.blackUltralight"
                      :size="9"/>
                    <span class="ellipsis">
                      Create Message Template
                    </span>
                  </div>
                </template>
                <template
                  slot="singleLabel"
                  slot-scope="{ option }">
                  {{ option }}
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  <span class="ellipsis">
                    {{ props.option }}
                  </span>
                </template>
                <template
                  v-if="!templateMessagesLoaded"
                  slot="afterList"
                  class="multiselect-title" >
                  <div
                    v-if="!tagsMeta || tagsMeta.current_page !== tagsMeta.last_page"
                    v-observe-visibility="hitBottomTemplateList">
                    <Spinner
                      class="mt-2 mb-2"
                      :size="17"
                      :thickness="2" />
                  </div>
                </template>
              </multiselect>
            </b-form-group>

            <!-- MESSAGE preview -->
            <!-- <b-form-group
              v-show="hasApprovedTemplateMessages" >
              <div class="template-label-wrapper flex space-between">
                <label>Message</label>
              </div> -->
              <!--eslint-disable vue/no-v-html-->
              <!-- <span
                id="popover-message"
                class="message box-shadow flex center-all" >
                <p
                  class="greedy"
                  v-html="message"/>
                <SBIcon
                  :icon="SBIconList.INFO"
                  color="#7DBCFA"
                  style="margin-left: 10px;"
                  :size="12"/>
              </span>
              <b-popover
                target="popover-message"
                triggers="hover"
                placement="top"
                delay="200"
                custom-class="basic-popover">
                Approved Message Template can't be edited.
              </b-popover>
            </b-form-group> -->

            <!-- TAGS -->
            <template v-if="selectedTemplateLanguageVersion">
              <b-form-group
                v-for="tag in selectedTemplateLanguageVersion.tags"
                :key="tag"
                class="tag-wrapper" >
                <label>Placeholder {{ tag }}</label>
                <ValidationProvider
                  :ref="tag"
                  v-slot="{ errors }"
                  :name="`Placeholder ${tag}`"
                  rules="required">
                  <SBTextInput
                    v-if="number.id"
                    :ref="`tag-area-${tag}`"
                    v-model="tagsToSend[tag]"
                    :focus-shadow="true"
                    :show-tags-select="true"
                    :enable-format-buttons="false"
                    :enable-emoji="false"
                    placeholder="Enter value"
                    :business-id="number.id"
                    :slim="true" />
                  <div
                    v-if="errors[0]"
                    class="error flex flex-align-center">
                    <SBIcon
                      :icon="SBIconList.ERROR"
                      :color="SBColors.redPrimary"
                      :size="12" />
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </b-form-group>
            </template>

            <!-- Dynamic link TAGS -->
            <template v-if="selectedTemplateLanguageVersion">
              <b-form-group
                v-for="(tag, index) in selectedTemplateLanguageVersion.button_tags"
                :key="index">
                <label class="flex flex-align-center">
                  Dynamic link extension
                  <SBIcon
                    id="dynamic-link-info"
                    class="ml-1"
                    :icon="SBIconList.INFORMATION"
                    :color="SBColors.greyPrimary"
                    :size="12" />
                  <b-popover
                    target="dynamic-link-info"
                    custom-class=""
                    boundary="window"
                    triggers="hover"
                    placement="top">
                    <div>
                      <h1>Dynamic link extension</h1>
                      <p>Please enter the desired link extension that will appear at the end of the link. For example: If you enter “products”, the resulting link will be "{{ linkExample }}/products".</p>
                    </div>
                  </b-popover>
                </label>
                <ValidationProvider
                  :ref="`button-tag-${index}`"
                  v-slot="{ errors }"
                  name="Dynamic link extension"
                  rules="required">
                  <b-form-input
                    v-model="buttonTagsToSend[tag.name]"
                    placeholder="Enter value"
                    @input="dynamicLinkChange" />
                  <div
                    v-if="errors[0]"
                    class="error flex flex-align-center">
                    <SBIcon
                      :icon="SBIconList.ERROR"
                      :color="SBColors.redPrimary"
                      :size="12" />
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </b-form-group>
            </template>

            <!-- FILE ATTACHMENT -->
            <template
              v-if="selectedTemplateLanguageVersion && selectedTemplateLanguageVersion.attachment">
              <b-form-group>
                <label
                  class="col-form-label p-0 m-0">
                  <span class="">{{ selectedTemplateLanguageVersion.attachment }}</span>
                </label>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Attachment"
                  rules="required" >
                  <DropZone
                    ref="dropZone"
                    v-model="files"
                    :placeholder="documentPlaceholder"
                    :extensions="allowedTemplateMessageAttachments(selectedTemplateLanguageVersion.attachment)"
                    @dropped-in="fileDropped"/>
                  <div
                    v-if="errors[0] && !$refs.dropZone.unsupportedFileType"
                    class="error flex flex-align-center">
                    <SBIcon
                      :icon="SBIconList.ERROR"
                      :color="SBColors.redPrimary"
                      :size="12" />
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </b-form-group>
            </template>

            <!-- UPDATE CONVERSATION LIST -->
            <div>
              <b-form-group>
                <label
                  class="col-form-label p-0 m-0">
                  <span class="">Update your existing conversation list</span>
                </label>
                <div class="flex gap-10">
                  <b-form-radio
                    ref="yesIconRef"
                    v-model="liveInbox"
                    class="broadcast-type"
                    :class="{ selected: liveInbox }"
                    name="some-radios"
                    :value="true">
                    <SBIcon
                      :icon="SBIconList.DONE_TICK"
                      :color="SBColors.white"
                      :background-color="liveInbox ? SBColors.bluePrimary : SBColors.greyLight"
                      :border-radius="50"
                      :size="6"
                      :hover-size="14" />
                    <span class="broadcast-type-name greedy">Yes</span>
                    <SBIcon
                      id="update-list-yes-info"
                      :icon="SBIconList.INFO"
                      :color="SBColors.greyPrimary"
                      :border-radius="50"
                      :size="12"
                      :hover-size="30" />
                    <b-popover
                      target="update-list-yes-info"
                      triggers="hover"
                      :placement="yesPopoverPlacemenet"
                      custom-class="big update-list-popover">
                      <h1 class="title">Your existing conversation list will be updated</h1>
                      <img
                        class="list-update-image"
                        srcset="~@/assets/img/SB-Images/update-conversation-list-yes/2x.png 2x ~@/assets/img/SB-Images/update-conversation-list-yes/3x.png 3x"
                        src="~@/assets/img/SB-Images/update-conversation-list-yes/1x.png" >
                      <h2>New conversations will be displayed</h2>
                      <p>New conversations started with a broadcast message will be displayed in the conversation list and sorted by newest.</p>
                      <img
                        class="list-update-image"
                        srcset="~@/assets/img/SB-Images/update-conversation-list-move/2x.png 2x ~@/assets/img/SB-Images/update-conversation-list-move/3x.png 3x"
                        src="~@/assets/img/SB-Images/update-conversation-list-move/1x.png" >
                      <h2>Conversation will be sorted by newest</h2>
                      <p>All conversations that were updated with a broadcast message will be sorted by newest and moved to the top of the list.</p>
                    </b-popover>
                  </b-form-radio>
                  <b-form-radio
                    ref="noIconRef"
                    v-model="liveInbox"
                    class="broadcast-type"
                    :class="{ selected: !liveInbox }"
                    name="some-radios"
                    :value="false">
                    <SBIcon
                      :icon="SBIconList.DONE_TICK"
                      :color="SBColors.white"
                      :background-color="!liveInbox ? SBColors.bluePrimary : SBColors.greyLight"
                      :border-radius="50"
                      :size="6"
                      :hover-size="14" />
                    <span class="broadcast-type-name greedy">No</span>
                    <SBIcon
                      id="update-list-no-info"
                      :icon="SBIconList.INFO"
                      :color="SBColors.greyPrimary"
                      :border-radius="50"
                      :size="12"
                      :hover-size="30" />
                    <b-popover
                      target="update-list-no-info"
                      triggers="hover"
                      :placement="noPopoverPlacemenet"
                      custom-class="big update-list-popover">
                      <h1 class="title">Keep your existing conversation list unchanged</h1>
                      <img
                        class="list-update-image"
                        srcset="~@/assets/img/SB-Images/update-conversation-list-no/2x.png 2x ~@/assets/img/SB-Images/update-conversation-list-no/3x.png 3x"
                        src="~@/assets/img/SB-Images/update-conversation-list-no/1x.png" >
                      <h2>New conversations won't be displayed</h2>
                      <p>A new conversation started with a broadcast message will only be displayed if the contact replies back.</p>
                      <img
                        class="list-update-image"
                        srcset="~@/assets/img/SB-Images/update-conversation-list-stay/2x.png 2x ~@/assets/img/SB-Images/update-conversation-list-stay/3x.png 3x"
                        src="~@/assets/img/SB-Images/update-conversation-list-stay/1x.png" >
                      <h2>Conversations won't be sorted by newest</h2>
                      <p>A broadcast message will be displayed within the existing conversation without listing that conversation as newest at the top of the list.</p>
                    </b-popover>
                  </b-form-radio>
                </div>
              </b-form-group>
            </div>

            <!-- INTEGRATIONS OPTIONS -->
            <div
              v-if="integrationsList.length"
              class="integration-options border-top" >

              <div
                v-for="(integration, index) of integrationsList"
                :key="index">
                <b-form-group>
                  <label
                    class="col-form-label flex flex-align-center pt-0">
                    <VNodes :vnodes="getIntegrationIcon(integration, '')"/>
                    {{ integration.integrationName }}
                    <DotSeparator :size="3" class="ml-1 mr-1" />
                    <p style="font-weight: 400 !important;">{{ integration.inboxName }}</p>
                  </label>
                  <multiselect
                    v-model="selectedIntegrationOptions[integration.inboxId]"
                    placeholder="Select Template"
                    class="integrations-multiselect-options hide-tags no-selected-background no-padding"
                    :options="integrationOptions"
                    :preselect-first="true"
                    :multiple="false"
                    :searchable="true"
                    :show-labels="false"
                    :show-no-results="false"
                    :allow-empty="false" >
                    <template slot="noOptions" >
                      <span class="hide" />
                    </template>
                    <template
                      slot="singleLabel"
                      slot-scope="{ option }">
                      <SBIcon
                        :icon="option.icon"
                        :color="SBColors.blackPrimary"
                        :size="option.iconSize"
                        :hover-size="12"
                        class="mr-2" />
                      {{ option.name }}
                    </template>
                    <template
                      slot="option"
                      slot-scope="props">
                      <SBIcon
                        :icon="props.option.icon"
                        :color="SBColors.blackPrimary"
                        :size="props.option.iconSize"
                        :hover-size="12" />
                      <span class="ellipsis">
                        {{ props.option.name }}
                      </span>
                    </template>
                  </multiselect>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
        <MessagePreview :content="messageContent"/>
      </div>

      <InfoCard
        v-else-if="!hasApprovedTemplateMessages"
        :flat-icon="SBIconList.MESSAGE_TEMPLATES_LOGO"
        title="Add WhatsApp Message Templates"
        :description="noTemplatesDescription"
        action-text="New"
        class="my-0"
        @action="showCreateNewMessageTemplateModal" />
    </b-modal>
  </ValidationObserver>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import { debounce } from 'debounce';

import { escapeHtml, whatsAppFormatToHTML, whatsappFormatMessage } from '@/helpers/stringHelpers';
import Spinner from '../../../common/Spinner';
import DropZone from '../../../common/DropZone';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import { allowedTemplateMessageAttachments } from '../../../../helpers/mediaHelpers';
import { getIntegrationIcon, getNumberIcon } from '@/helpers/lists/branchIcons';
import VNodes from '@/components/common/VNodes';
import SBTextInput from '@/components/business/widgets/SBTextInput';
import DotSeparator from '@/components/common/DotSeparator';
import JuneMixin from '@/mixins/June';
import InfoCard from '@/components/common/InfoCard';
import MessagePreview from '@/components/common/MessagePreview';

export default {
  name: 'BroadcastModal',
  components: {
    Multiselect,
    DropZone,
    SBIcon,
    Spinner,
    VNodes,
    SBTextInput,
    DotSeparator,
    InfoCard,
    MessagePreview,
  },
  mixins: [
    JuneMixin,
  ],
  props: {
    contacts: {
      type: Array,
      default: null,
    },
    deselectedContacts: {
      type: Array,
      required: false,
      default: () => [],
    },
    selectedContacts: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      whatsappPolicyUrl: 'https://www.whatsapp.com/legal/business-policy/',
      files: [],
      formData: new FormData(),
      languages: [],
      selectedLanguage: null,
      selectedTemplate: null,
      selectedTemplateObject: null,
      selectedTemplateLanguageVersion: null,
      tagsToSend: {},
      buttonTagsToSend: {},
      visible: false,
      tempBackupOfValues: null,
      templateMessageListCombined: [],
      tagsMeta: null,
      number: null,
      liveInbox: true,
      integrationOptions: [
        {
          name: 'Don\'t import broadcast messages',
          value: false,
          icon: SBIconList.CLOSE_THIN,
          iconSize: 10,
        },
        {
          name: 'Import broadcast messages',
          value: true,
          icon: SBIconList.REFRESH_DOUBLE,
          iconSize: 12,
        },
      ],
      selectedIntegrationOptions: {},
      filterId: null,
      searchQuery: null,
      contactIds: null,
      selectAll: false,
      yesPopoverPlacemenet: 'top',
      noPopoverPlacemenet: 'top',
      SBIconList,
      SBColors,
      messageContent: {},
    };
  },
  computed: {
    ...mapGetters({
      templateMessageList: 'notification/templateMessageList',
      templateMessagesLoaded: 'notification/templateMessagesLoaded',
      me: 'organisation/me',
      apiError: 'notification/apiError',
      notificationTags: 'notification/notificationTags',
      notificationTagsLoaded: 'notification/notificationTagsLoaded',
      currentOrganisationIntegrations: 'organisation/currentOrganisationIntegrations',
      maxBroadcastNumbers: 'system/maxBroadcastNumbers',
    }),
    noTemplatesDescription() {
      return `Create a Message Template so you can initiate a WhatsApp broadcast or respond to a conversation if more than 24 hours have passed from the last message sent by the contact. Visit <a href='${this.whatsappPolicyUrl}' target='_blank'>WhatsApp Business Legal</a> for more information.`
    },
    integrationsList() {
      const integrations = [];
      if (!this.number) {
        return integrations;
      }
      this.currentOrganisationIntegrations.forEach((oi) => {
        oi.business.forEach((b) => {
          if (b.uid === this.number.id) {
            integrations.push({
              integrationName: oi.alternative_name,
              inboxName: b.inbox_name,
              inboxId: b.inbox_id,
              code: oi.code,
            });
          }
        });
      });

      return integrations;
    },
    linkExample() {
      const link = this.selectedTemplateLanguageVersion.buttons.length ? this.selectedTemplateLanguageVersion.buttons[0].value : '';
      return link.replace(/\/?\{\{\d\}\}$/, '');
    },
    /** Checks if there is at least one approved template message. */
    hasApprovedTemplateMessages() {
      return this.templateMessagesLoaded && this.templateKeywords.length;
    },
    maxBroadcastCalc() {
      const availableMessagesOnNumber = this.number && this.number.whatsapp ? this.number.whatsapp.daily_message_limit - this.number.whatsapp.rolling_24h_sent : 0;
      return this.maxBroadcastNumbers > availableMessagesOnNumber ? availableMessagesOnNumber : this.maxBroadcastNumbers;
    },
    /** Computes the message content from the tags data populated by user. */
    message() {
      let selectedTemplateMessage = this.selectedTemplateLanguageVersion ? escapeHtml(this.selectedTemplateLanguageVersion.text.trim()) : '';
      if (this.selectedTemplateLanguageVersion) {
        this.selectedTemplateLanguageVersion.tags.forEach((tag) => {
          if (this.tagsToSend[tag]) {
            selectedTemplateMessage = selectedTemplateMessage.replace(new RegExp(`\\{\\{${tag}\\}\\}`, 'g'), this.tagsToSend[tag]);
          }
        });
        selectedTemplateMessage = selectedTemplateMessage.replace(/{{(.*?)}}/g, '<span class="editor-tag ellipsis">$1</span>');
      }
      return whatsAppFormatToHTML(selectedTemplateMessage).replace(/>(\s*)</gi, '><');
    },
    /** Creates a list of approved template names to be populated on the templates multiselect. */
    templateKeywords() {
      // TODO this is probably not needed anymore since we do not refference keyword anywhere on frontend. Refactor this on rewrite
      const templateKeywords = [];
      this.templateMessageListCombined.forEach((template) => {
        if (template.status === 'approved') {
          templateKeywords.push(template.name || template.keyword);
        }
      });

      return templateKeywords;
    },
    hasFieldsToPopulate() {
      return !!(this.selectedTemplateLanguageVersion && (this.selectedTemplateLanguageVersion.tags.length || this.selectedTemplateLanguageVersion.attachment));
    },
    documentPlaceholder() {
      let placeholder = 'Select or drop JPG, JPEG, or PNG here';
      switch (this.selectedTemplateLanguageVersion.attachment) {
        case 'video':
          placeholder = 'Select or drop MP4 here';
          break;
        case 'document':
          placeholder = 'Select or drop PDF here';
          break;
        default:
          break;
      }
      return placeholder;
    },
  },
  watch: {
    /** Sets the selected template object and resets the tags input on template change. */
    selectedTemplate() {
      this.resetTags();
      if (this.selectedTemplate) {
        this.selectedTemplateObject = this.templateMessageList[this.selectedTemplate.replace(/\s/g, '_')];
      }
    },
    /** Sets the available languages for the selected template. */
    selectedTemplateObject() {
      this.selectedLanguage = null;
      // this.languages = this.selectedTemplateObject.map(templateVersion => ({
      //   languageName: getLanguageName(templateVersion.language, false),
      //   languageCode: templateVersion.language,
      // }));
      // select language automatically if only one is available
      if (this.languages.length === 1) {
        [this.selectedLanguage] = this.languages;
      }
    },
    /** Resets tags on language change. */
    // DEPRECATED
    selectedLanguage() {
      this.resetTags();
      if (!this.selectedLanguage) {
        this.selectedTemplateLanguageVersion = null;
      } else {
        this.selectedTemplateLanguageVersion = this.selectedTemplateObject.find(
          template => template.language === this.selectedLanguage.languageCode,
        );
      }
    },
    tagsToSend: {
      handler() {
        this.setModalBackupData();
      },
      deep: true,
    },
    templateMessageList() {
      if (this.tempBackupOfValues && this.tempBackupOfValues.language) {
        const targetTemplate = this.templateMessageList.data.find(template => template.id === this.tempBackupOfValues.language);
        if (targetTemplate && targetTemplate.status === 'approved') {
          this.selectedTemplate = targetTemplate.name || targetTemplate.keyword;
          this.changeTemplate();
          this.$nextTick(() => {
            if (this.tempBackupOfValues.tagValues) {
              this.tagsToSend = { ...this.tempBackupOfValues.tagValues };
            }
          });
        }
      }
      this.templateMessageListCombined = [...this.templateMessageListCombined, ...this.templateMessageList.data];
      this.changeTemplate();
    },
    message() {
      this.setPreview();
    },
  },
  mounted() {
    window.addEventListener('resize', () => this.setPopoverPositions());
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => this.setPopoverPositions());
  },
  methods: {
    ...mapActions({
      fetchTemplateMessages: 'notification/fetchTemplateMessages',
      loadAvailableNotificationTags: 'notification/loadAvailableNotificationTags',
      addMessageToFastLoad: 'chat/addMessageToFastLoad',
      sendBroadcast: 'notification/sendBroadcast',
    }),
    getNumberIcon,
    whatsappFormatMessage,
    getIntegrationIcon,
    allowedTemplateMessageAttachments,
    changeTemplate() {
      this.tagsToSend = {};
      this.buttonTagsToSend = {};
      this.files = [];
      this.formData.delete('file');
      if (this.$refs.dropZone) {
        this.$refs.dropZone.clearFiles();
      }
      this.selectedTemplateLanguageVersion = this.templateMessageListCombined.find(template => template.name === this.selectedTemplate || template.keyword === this.selectedTemplate);
      this.setModalBackupData();
      this.setPreview();
    },
    /** Loads more templates if dropdown is visible and if scroll is not active. */
    checkIfTemplatesListNeedsMore() {
      if (!this.$refs.templateMultiselectRef) {
        if (!this.hasApprovedTemplateMessages) {
          this.loadTemplates(true);
        }
        return;
      }
      const targetMultiselectContent = this.$refs.templateMultiselectRef.$el.getElementsByClassName('multiselect__content-wrapper');
      if (!this.hasApprovedTemplateMessages || (targetMultiselectContent[0] && targetMultiselectContent[0].clientHeight !== 0 && targetMultiselectContent[0].scrollHeight === targetMultiselectContent[0].clientHeight)) {
        this.loadTemplates(true);
      }
    },
    dynamicLinkChange: debounce(function f() {
      this.setPreview();
    }, '100'),
    /** Handles file drop on the file input. */
    fileDropped(file) {
      if (file && file.length) {
        this.formData.set('file', file[0]);
      } else {
        this.formData.delete('file');
      }
      this.setPreview();
    },
    onShow() {
      this.visible = true;
      this.setPopoverPositions();
    },
    onHide() {
      this.visible = false;
    },
    setPopoverPositions() {
      try {
        this.yesPopoverPlacemenet = this.$refs.yesIconRef.$el.getBoundingClientRect().top > 460 ? 'top' : 'right';
        this.noPopoverPlacemenet = this.$refs.noIconRef.$el.getBoundingClientRect().top > 460 ? 'top' : (this.$refs.noIconRef.$el.getBoundingClientRect().right > 390 ? 'right' : 'left');  
      } catch (error) {
        // console.log('');
      }
    },
    hitBottomTemplateList(reached) {
      if (reached) {
        this.loadTemplates(true);
      }
    },
    /** Resets the data on the template form. */
    resetData() {
      this.visible = false;
      this.resetTags();
      this.selectedTemplate = null;
      this.templateMessageListCombined = [];
      this.tagsMeta = null;
      this.$refs.broadcastForm.reset();
    },
    /** Resets tags. */
    resetTags() {
      this.tagsToSend = {};
      this.$refs.broadcastForm.reset();
    },
    /** Brings up the moda, fetches the templates and sets the recepient. */
    show(number, contactIds = null, selectAll = false, filterId = null, searchQuery = null) {
      this.visible = true;
      this.number = number;
      this.contactIds = contactIds;
      this.selectAll = selectAll;
      this.filterId = filterId;
      this.searchQuery = searchQuery;
      this.$nextTick(() => {
        this.$refs.broadcastModalRef.show();
        this.loadTemplates(number.id);
      });
    },
    hide() {
      this.$refs.broadcastModalRef.hide();
    },
    loadTemplates(numberId, background = false) {
      if (this.tagsMeta && this.tagsMeta.current_page >= this.tagsMeta.last_page) {
        return;
      }
      const data = {
        limit: 3000,
        order: 'name',
        status: 'approved',
        page: this.tagsMeta ? this.tagsMeta.current_page + 1 : 1,
      };
      this.fetchTemplateMessages({ businessId: numberId, data, background })
        .then((response) => {
          this.tagsMeta = response.data.meta;
          this.checkIfTemplatesListNeedsMore();
        });
    },
    /** Starts sending broadcast messages. */
    submit() {
      this.formData.delete('all_contacts');
      this.$refs.broadcastForm.validate();
      if (this.$refs.broadcastForm.flags.valid) {
        const sendData = {};
        Object.keys(this.tagsToSend).forEach((tag) => {
          sendData[tag] = this.whatsappFormatMessage(this.$refs[`tag-area-${tag}`][0].messageContentWithTagsRecalculated);
        });

        this.formData.set('channel', 'whatsapp');
        this.formData.set('template_id', this.selectedTemplateLanguageVersion.id);
        this.formData.set('tags', JSON.stringify(sendData));
        this.formData.set('live_inbox', this.liveInbox);

        // tags for dynamic link buttons
        if (Object.keys(this.buttonTagsToSend).length) {
          this.formData.set('button_tags', JSON.stringify(this.buttonTagsToSend));
        }

        if (this.integrationsList.length) {
          const integrationsToSkip = {};
          Object.keys(this.selectedIntegrationOptions).forEach((integrationKey) => {
            const integration = this.integrationsList.find(il => il.inboxId === integrationKey);
            if (!this.selectedIntegrationOptions[integrationKey].value) {
              integrationsToSkip[integration.code] = integration.inboxId;
            }
          });
          this.formData.set('skip_integrations', JSON.stringify(integrationsToSkip));
        }

        if (this.selectAll) {
          this.formData.delete('filter_id');
          this.formData.delete('search_query');
          if (this.filterId) {
            this.formData.set('filter_id', this.filterId);
          }
          if (this.searchQuery) {
            this.formData.set('search_query', this.searchQuery);
          }
          if (this.deselectedContacts.length) {
            this.formData.set('deselected_contacts_ids', JSON.stringify(this.deselectedContacts));
          }
          if (!this.filterId && !this.searchQuery) {
            this.formData.set('all_contacts', true);
          }

          this.formData.delete('contacts_ids');
        } else {
          this.formData.set('contacts_ids', JSON.stringify(this.contactIds));
          this.formData.delete('filter_id');
          this.formData.delete('deselected_contacts_ids');
        }

        const payload = {
          businessId: this.number.id,
          data: this.formData,
        };

        // TODO Make it work as "assume success"
        // 1. When send is clicked initiate send and show message on the messages list
        // 2. if message is sent everything stays as is
        // 3. If message send fails it will be updated on the messages list
        // 4. if the request itself fails then show the message to user, remove it from message list and show the prepopulated modal again.
        // const outboundMessageData = {
        //   sid: tempSid,
        //   body: whatsappFormatMessage(this.message), // TODO test this with template that has something bolded
        //   media_type: null,
        //   media_url: null,
        //   loaded: true,
        //   direction: 'template_message',
        //   status: 'sending',
        //   sent_at: this.$moment().unix(),
        //   agent: {
        //     name: this.me.name,
        //   },
        // };
        // this.$eventBus.$emit('addoutboundmessage', outboundMessageData);
        // this.addMessageToFastLoad({
        //   message: outboundMessageData,
        //   conversation_uid: this.activeConversation.id,
        // });

        // const previousUserId = this.activeConversation.user_id;

        // this.$eventBus.$emit('template-message-assign', {
        //   conversationId: payload.conversation_id,
        // });

        // console.log(this.formData.get('filter_id'));
        // console.log(this.formData.get('search_query'));
        // console.log(this.formData.get('deselected_contacts_ids'));
        // console.log(this.formData.get('tags'));
        // console.log(this.formData.get('skip_integrations'));
        // console.table([...payload.data]);

        this.sendBroadcast(payload)
          .then((response) => {
            if (response.status === 200) {
              this.juneTrack('Broadcast sent', { broadcastId: response.data.broadcast_id, noOfRecipients: this.selectedContacts });
            }
          });

        this.$emit('broadcast-sent');
        this.hide();
      }
    },
    cancelBroadcast() {
      this.resetData();
    },
    setModalBackupData() {
      if (!this.visible) {
        return;
      }
      const backupValues = {
        language: this.selectedTemplateLanguageVersion ? this.selectedTemplateLanguageVersion.id : '',
      };
      const backupTagValues = {};
      Object.keys(this.tagsToSend).forEach((tag) => {
        backupTagValues[tag] = this.tagsToSend[tag];
      });
      backupValues.tagValues = { ...backupTagValues };
    },
    showCreateNewMessageTemplateModal() {
      if (this.$refs.templateMultiselectRef) {
        const allOptions = this.$refs.templateMultiselectRef.$el.getElementsByClassName('multiselect__element');
        let targetOption;
        const proccessedSelectedTemplateName = this.$options.filters.removeUnderscore(this.selectedTemplate || '');
        for (let i = 0; i < allOptions.length; i++) {
          if (allOptions[i].innerText.trim() === proccessedSelectedTemplateName) {
            targetOption = allOptions[i];
            break;
          }
        }
        if (targetOption && targetOption.children[0]) {
          targetOption.children[0].click();
        }
      }

      this.$emit('create-new-template');
    },
    setPreview() {
      this.messageContent.text = this.message;
      this.messageContent.attachmentType = this.selectedTemplateLanguageVersion ? this.selectedTemplateLanguageVersion.attachment : null;
      this.messageContent.attachment = this.formData.has('file') ? this.formData.get('file') : '';
      // Buttons
      this.messageContent.buttons = [];
      if (this.selectedTemplateLanguageVersion && this.selectedTemplateLanguageVersion.buttons && this.selectedTemplateLanguageVersion.buttons.length) {
        this.selectedTemplateLanguageVersion.buttons.forEach((b) => {
          let value = b.value;
          if (this.selectedTemplateLanguageVersion.button_tags) {
            this.selectedTemplateLanguageVersion.button_tags.forEach((tag) => {
              if (this.buttonTagsToSend[tag.name]) {
                value = value.replace(new RegExp(`\\{\\{${tag.name}\\}\\}`, 'g'), `{{${this.buttonTagsToSend[tag.name]}}}`);
              }
            });
          }

          this.messageContent.buttons.push({
            value,
            title: b.title,
            icon: b.icon,
            type: b.type,
          });
        });
      }
      this.$nextTick(() => {
        this.messageContent = { ...this.messageContent };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #broadcast-send-modal {
  .modal-body {
    margin: 0 !important;
    padding: 0 !important;
  }

  &.preloading .modal-body {
    background: $white !important;
    border-radius: 5px;
  }

  &.modal:not(.fit-width) .modal-dialog {
    // width: 484px!important;
    max-width: 780px !important;
    width: calc(100% - 16px) !important;
  }

  .notification-send-form {
    padding: 20px;
    min-width: 1%;
    .template-label-wrapper {
      z-index: 200;

      .multiselect {
        display: inline-block;
        max-width: fit-content;
        min-height: 16px !important;
        height: 16px;
        box-shadow: none;

        &:focus {
          box-shadow: unset !important;
        }

        .multiselect__select {
          padding: 0;
          height: 11px;
          width: 11px;
        }

        .multiselect__tags {
          padding: 0;
          min-height: 16px;
          height: 16px;
          border: none;

          .multiselect__single {
            font-size: 14px !important;
            line-height: 1.2 !important;
            color: $greyPrimary !important;
            padding-right: 18px !important;
          }
        }

        &.hover {
          .multiselect__single {
            color: $blackPrimary !important;
          }
          .multiselect__select {
            mask-image: url(~@/assets/img/SB-Icons/down-arrow.svg);
            mask-size: 11px auto !important;
            mask-repeat: no-repeat;
            mask-position: center;
            background-color: $blackPrimary;
          }
        }

        .multiselect__content-wrapper {
          width: 212px;
          right: 0;
          z-index: 101;
          margin-top: 4px;

          .multiselect__content {
            .lang-list-label {
              display: block !important;
              font-size: 12px !important;
              line-height: 1.4 !important;
              padding: 10px 0 3px 12px !important;
              color: $greyPrimary !important;
            }

            .multiselect__element {
              .multiselect__option {
                padding: 5px 12px !important;
                font-size: 14px !important;
                line-height: 1.2 !important;
                color: $blackPrimary !important;
                display: flex !important;
              }
            }
          }
        }
      }
    }

    .number-from-wrapper {
      padding: 0 10px;
      border-radius: 5px;
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
      border: solid 1px $greyBorder;
      background-color: $white;
      min-height: 30px;

      .branch-icon {
        margin-right: 7px;
        margin-top: 3px;
        &.FRONTAPP,
        &.FRONTPACHA {
          background-image: url('~@/assets/img/SB-Icons/integration-front-color.svg');
          background-size: 14px 14px;
          background-position: center center;
          background-repeat: no-repeat;
          display: block;
          width: 18px;
          height: 18px;
          margin-top: 0px;
        }
      }

      p {
        margin-top: 1px;
      }
    }

    .broadcast-type {
      cursor: pointer;
      margin: 0 0 0 0;
      padding: 0 0 0 0;
      border-radius: 5px;
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
      border: solid 1px greyBorder;
      background-color: #edf0f2;
      width: 50%;
      border: solid 1px #d9dfe2;
      // line-height: unset !important;

      // * {
      //   line-height: unset !important;
      // }

      &:hover {
        box-shadow: 0 1px 3px 0 rgba(48,54,70,.3) !important;
      }

      &.selected {
        background-color: #edf8ff;
        border: solid 1px $greyBorder;
      }

      input {
        visibility: hidden;
      }

      label {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0 !important;
        padding: 0 1px 0 10px !important;

        &::before, &::after {
          display: none !important;
        }

        .broadcast-type-name {
          padding: 0 10px;
        }
      }
    }

    .integration-options {
      margin-top: 20px !important;
      padding-top: 4px !important;

      .form-group {
        margin-top: 16px;
      }
    }

    label, label * {
      font-weight: 500 !important;
    }
  }

  &.hide-send {
    .modal-body {
      background-color: $white;
    }

    .modal-footer .btn-primary {
      display: none;
    }
  }
}

::v-deep .info-card {
  margin: 20px !important;
  .action .btn {
    margin: 0 !important;
    font-family: HelveticaNeue !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    padding: 6px 13px !important;
    min-width: unset !important;
    .sb-icon .icon.mask {
      background-color: $white !important;
    }
  }
}

::v-deep .multiselect.empty {
  ul.multiselect__content {
    height: 32px;
    overflow: hidden;
  }
}

::v-deep .integrations-multiselect-options,
::v-deep .template-multiselect-options {
  .multiselect__select {
    z-index: 0 !important;
  }

  .multiselect__single {
    display: flex !important;
    align-items: center !important;
  }

  .multiselect__content-wrapper {
    // z-index: 999;
    ul.multiselect__content li.multiselect__element > span {
      display: flex !important;
      align-items: center !important;

      .sb-icon {
        margin: 0 15px 0 5px !important;
      }
    }
  }
}

::v-deep .template-multiselect-options {
  .multiselect__content-wrapper {
    // z-index: 999;
    ul.multiselect__content li.multiselect__element > span {
      .sb-icon {
        visibility: hidden;
      }
    }
  }
  .multiselect__option--selected .sb-icon{
    visibility: visible !important;
  }
}

#broadcast-send-modal {
  .modal-title .icon {
    top: 2px;
    position: relative;
  }

  .modal-content {
    .modal-body {
      .spinner-wrapper {
        margin: 20px;
      }
    }
  }

  .check-consent {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .loader {
      position: unset !important;
      width: unset !important;
      margin: unset !important;
      margin-right: 5px !important;
    }
  }

  .contacts-spinner, .clear-contact {
    position: absolute;
    right: 10px;
    left: unset;
    top: 31px;
    width: fit-content;
    margin: 0;
    z-index: 100;
  }

  .clear-contact {
    padding: 8px;
    width: 30px;
    height: 30px;
    right: 6px;
    top: 23px;
  }

  .multiselect, input {
    height: 100%;
    border-radius: 5px;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
    &:focus {
      box-shadow: 0 0 0 3px #bfdeff !important;
    }
  }

  input {
    border: solid 1px #cfd8dc !important;
    background-color: #ffffff !important;
    padding: 7px 10px !important;
  }

  .message {
    display: block;
    border-radius: 5px;
    border: solid 1px #cfd8dc;
    background-color: $white;
    padding: 7px 10px;
    color: $blackPrimary;
    font-size: 14px;
    min-height: 32px;
    cursor: pointer;

    // .message code {
    //   position: relative;
    //   bottom: 1px;
    //   background-color: #fff;
    //   padding: 0 8px;
    //   border-radius: 30px;
    //   border: 1px solid $blackPrimary;
    //   font-weight: 500 !important;
    //   text-transform: capitalize;
    //   font-size: 12px !important;
    // }

    ::v-deep {
      p b {
        font-weight: 600 !important;
      }

      p p {
        min-height: 10px;
      }

      .editor-tag,
      span code {
        position: relative;
        bottom: 1px;
        background-color: #fff;
        padding: 0 8px;
        border-radius: 30px;
        border: 1px solid $blackPrimary;
        font-weight: 500 !important;
        text-transform: capitalize;
        font-size: 12px !important;
        color: $blackPrimary;
        font-family: inherit;
      }
    }
  }

  .send-btn {
    display: flex;
    align-items: center;
    margin-top: 22px;

    .loader {
      margin-right: 4px;
    }

    .message-sent {
      display: flex;

      img {
        margin-top: 0;
        margin-bottom: 0;
        margin-right: 5px;
      }
    }
  }

  .main-error, .message-sent {
    margin-top: 22px !important;
  }

  .error {
    color: $redPrimary;
    margin-top: 5px;
    padding: 5px 11px 5px 6px;

    .sb-icon {
      margin-right: 6px;
    }
  }
}

.broadcast-info-wrapper {
  white-space: pre;

  &>span {
    font-weight: 500;
  }
  .broadcast-count {
    color: $blackUltralight;

    &.ok {
      color: $bluePrimary;
    }

    &.nok {
      color: $redPrimary;
    }
  }

  .recepients {
    color: $blackUltralight;
  }
}

::v-deep .multiselect.no-selected-background .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight {
  // background-color: unset !important;
}

::v-deep .multiselect.no-selected-background .multiselect__content-wrapper .multiselect__content .multiselect__element:hover {
  background-color: $hover !important;
}

.multiselect-before {
  color: $blackUltralight;
  padding: 8px 10px;

  .sb-icon {
    margin-right: 15px;
    margin-left: 5px;
  }

  &:hover {
    background-color: $hover;
    color: $bluePrimary;

    ::v-deep .sb-icon .icon.mask {
      background-color: $bluePrimary !important;
    }
  }
}

.integration-icon {
  background-size: contain !important;
  font-size: 14px !important;
  margin: 0 5px 0 0;
  line-height: 1;

  &.FRONTAPP, &.FRONTPACHA {
    height: 14px !important;
    width: 14px !important;
    background-size: 14px 14px;
    background-position: center center;
    background-repeat: no-repeat;
    display: block;
  }
}

.tag-wrapper {
  position: relative;

  input {
    padding: 7px 32px 7px 10px !important;
  }
  .tag-btn {
    position: absolute;
    right: 5px;
    bottom: 4px;
    cursor: pointer;
  }
}

::v-deep .update-list-popover {
  width: 354px;

  .list-update-image {
    margin-left: -4px;
    width: calc(100% + 4px); // To compensate for the shadow on the image
    margin-top: 26px;
  }

  h1 {
    font-size: 16px;
  }

  h2 {
    margin-top: 8px;
    font-weight: 600;
    font-size: 14px;
  }

  p {
    margin-top: 4px;
    font-size: 14px;
  }
}

::v-deep .no-padding .multiselect__content {
  padding: 0 0 !important;
}
</style>

<style lang="scss">
#broadcast-send-modal {
  .modal-dialog {
    container: form-input / inline-size;
  }

  footer button.btn {
    width: auto;
  }
}

@container form-input (inline-size < 625px) {
  #broadcast-send-modal {
    .preview-body {
      flex-direction: column;

      .preview {
        width: 100%;
        border-left: none;
        border-top: 1px solid #E6EBED;
      }
    }
  }
}
</style>
